import logo from './logo.svg';
import './App.css';
import Prac from './prac1'
function App() {
  return (
    <div className="App">
     <Prac/> 
    </div>
  );
}

export default App;
